import type { ProductMinimal } from '@travelity/api';
import type { PackageFormValues } from '@/views/add-package/add-package.types';

const MAX_DAY_OPTION = 30;

export const buildDayOptions = (minDay: number): number[] => {
    const daysList: number[] = [];
    for (let day = minDay; day <= MAX_DAY_OPTION; day += 1) {
        daysList.push(day);
    }
    return daysList;
};

export const getStartTimeFieldPaths = (
    days: PackageFormValues['products']
): string[] => {
    return days.flatMap((day, dayIndex) =>
        (day.items || []).map(
            (_, itemIndex) =>
                `products.${dayIndex}.items.${itemIndex}.start_time`
        )
    );
};

export const getGlobalCurrencyAbbr = (
    days: PackageFormValues['products']
): string | undefined => {
    const allSelectedProducts = days.flatMap(day => day.items || []);
    return allSelectedProducts[0]?.currency?.abbr;
};

export const getUnitProductsStepErrors = (
    days: PackageFormValues['products'],
    errors: string[]
): string[] => {
    const hasEmptyDay = days.some(day => (day.items || []).length === 0);
    const emptyDayError = hasEmptyDay
        ? 'Each day must have at least 1 product'
        : undefined;

    return [emptyDayError, ...errors].filter(Boolean) as string[];
};

export const canAddProductByGlobalCurrency = (
    products: PackageFormValues['products'],
    candidate: ProductMinimal
): boolean => {
    const existingProducts = products.flatMap(day => day.items || []);
    const packageCurrencyAbbr = existingProducts[0]?.currency?.abbr;
    if (!packageCurrencyAbbr) return true;
    return candidate.currency?.abbr === packageCurrencyAbbr;
};
